import {
  AppBar,
  Box,
  IconButton,
  Stack,
  Toolbar,
  Typography,
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { useEffect, useState } from 'react'
import { DataGrid, GridToolbar } from '@mui/x-data-grid'
import { getTaskDetailsData } from './HomepageServices'
import React from 'react';

const columns = [
  {
    field: 'input_smiles',
    headerName: 'Input Smiles',
  },
  {
    field: 'similar_smiles',
    headerName: 'Similar Smiles',
  },
  {
    field: 'chemblid',
    headerName: 'Chembl Id',
  },
  {
    field: 'similarity_created_date',
    headerName: 'Similarity Created Date',
  },
  {
    field: 'similarity_score',
    headerName: 'Similarity Score',
  },
  {
    field: 'ligand_name',
    headerName: 'Ligand Name',
  },
  {
    field: 'pdb',
    headerName: 'PDB',
  },
  {
    field: 'uniprotid',
    headerName: 'Uniprot Id',
  },
  {
    field: 'drug_class',
    headerName: 'Drug Class',
  },
  {
    field: 'target_name',
    headerName: 'Target Name',
  },
  {
    field: 'binding_similarity_score',
    headerName: 'Binding Similarity Score',
  },
  {
    field: 'dtp_docking_score',
    headerName: 'DTP Docking Score',
  },
  {
    field: 'ligand_similarity_score',
    headerName: 'Ligand Similarity Score',
  },
  {
    field: 'ligt_map_score',
    headerName: 'TargetPred Score',
  },
  {
    field: 'predicted_affinity',
    headerName: 'Predicted Affinity',
  },
  {
    field: 'dtp_created_date',
    headerName: 'DTP Created Date',
  },
  {
    field: 'docking_score',
    headerName: 'Docking score',
  },
  {
    field: 'docking_created_date',
    headerName: 'Docking Created Date',
  }
]

function addId(targetJson) {
  let iterator = 1
  targetJson.map((target) => {
    target.id = iterator
    iterator++
  })
  return targetJson
}

const TaskResultDetails = ({ smiles, handleOnClose }) => {
  const [rows, setRows] = useState([])
  useEffect(() => {
    getTaskDetailsData(smiles).then((data) => {
      console.log(data)
      addId(data)
      setRows(data)
    })
  }, [smiles])

  return (
    <Box sx={{ width: '100%', height: '100%' }}>
      <AppBar sx={{ height: '4rem' }}>
        <Toolbar>
          <Stack direction="row" spacing={2}>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleOnClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography
              variant="h6"
              gutterBottom
              sx={{ marginBottom: 0, alignSelf: 'center' }}
            >
              Task Results
            </Typography>
          </Stack>
        </Toolbar>
      </AppBar>
      <Box sx={{ height: '98%', paddingTop: '4rem' }}>
        <DataGrid
          rows={rows}
          columns={columns}
          initialState={{
            pagination: {
              paginationModel: { page: 0, pageSize: 10 },
            },
            sorting: {
              sortModel: [{ field: 'dtp_docking_score', sort: 'desc' }],
            },
          }}
          pageSizeOptions={[10, 25, 50, 10]}
          slots={{ toolbar: GridToolbar }}
        />
      </Box>
    </Box>
  )
}
export default TaskResultDetails
